import "react-phone-input-2/lib/bootstrap.css";
import { closeicon } from "assets/icons/index";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";

interface SmsDonationPopupProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  project?: any;
}

const SmsDonationPopup = ({
  show,
  setShow,
  project,
}: SmsDonationPopupProps) => {
  const { t, i18n } = useTranslation();

  const { smsDonationLoading, smsDonationData } = useSelector(
    (state: RootState) => state.smsDonationReducer
  );

  // console.log(smsDonationData);
  // console.log(project);

  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="300"
      className="fixed top-0 left-0 z-[50] w-full h-screen bg-black/40 flex items-center justify-center"
    >
      <Spin spinning={smsDonationLoading}>
        <div className="w-[340px] md:w-[730px] p-[25px] lg:p-[36px] bg-white rounded-[20px] flex flex-col gap-[35px]">
          {/* main title  */}
          <div className="w-full flex items-center justify-between">
            <p
              className={`font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600] text-[18px] lg:text-[24px] text-second_color text-center`}
            >
              {i18n.language === "en" ? project?.title_en : project?.title_ar}
            </p>

            <img
              onClick={() => setShow(!show)}
              className="cursor-pointer"
              src={closeicon}
              alt=""
            />
          </div>

          {/* donations part  */}
          <div className="flex flex-col gap-2 max-h-[500px] overflow-y-scroll lg:overflow-y-hidden ">
            {smsDonationData?.map((item: any, i: number) => {
              return (
                <>
                  {/* single value  */}
                  <div
                    key={i}
                    className="flex flex-col items-center justify-between gap-2 lg:gap-0 md:flex-row pb-[15px] border-b-[1px]"
                  >
                    <p
                      className={`font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[700] text-[16px] text-first_color`}
                    >
                      {item?.amount} {t("AED")}
                    </p>
                    <p
                      className={`font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[400] text-[16px] `}
                    >
                      Etisalat - DU
                    </p>
                    <a
                      href={`sms:${item?.recipient}?body=${
                        i18n.language === "en" ? item?.msg_en : item?.msg_ar
                      }`}
                      className={`font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-white text-[15px] w-[152px] h-[40px] bg-first_color rounded-[10px] hover:bg-[#614629] hover:text-white duration-300 flex items-center justify-center `}
                    >
                      {t("Donate Now")}
                    </a>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </Spin>
    </section>
  );
};

export default SmsDonationPopup;
